import styled from 'styled-components';

import { color } from '../../tokens';
import { TextS } from '../common/typography';

export const ErrorMessage = styled(TextS)`
  color: ${color.errorText};
  padding-left: 5px;
`;
